import { useTranslation } from '@hopin-team/provider-translation';
import cx from 'classnames';
import React from 'react';

export type OptionTab = 'option_1' | 'option_2';

export interface ContentOptionTabsProps {
  count: number;
  selectedOptionIndex: number;
  onOptionChange: (index: number) => void;
  className?: string;
}

export const ContentOptionTabs: React.FC<ContentOptionTabsProps> = ({
  count = 1,
  selectedOptionIndex,
  onOptionChange,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx('flex items-center', className)}
      data-testid="content-option-tabs"
    >
      {Array.from({ length: count }).map((_, index) => (
        <button
          key={index}
          type="button"
          onClick={() => onOptionChange(index)}
          className={cx(
            'text-xs font-semibold transition-colors pb-2 border-b-2 text-spring-neutral-b3 px-4',
            {
              'border-spring-cobranding': selectedOptionIndex === index,
              'border-transparent': selectedOptionIndex !== index,
            },
          )}
          data-testid={`option-tab-${index + 1}`}
        >
          {t(`content-recording.content-composer.options.option-${index + 1}`)}
        </button>
      ))}
    </div>
  );
};
